import type { Event, ShowStop } from '../services/events';
import { compareVersions } from './bridgeLaunch';
import type { QueueLevel } from './localFileLevels';

export const LAST_SONG_MIN_BRIDGE_VERSION = '1.13.0';

export function parseShowStop(raw: unknown): ShowStop | null {
  if (!raw || typeof raw !== 'object') return null;
  const value = raw as Record<string, unknown>;
  if (typeof value.stoppedAt !== 'string' || !value.stoppedAt) return null;
  if (typeof value.requestId !== 'string' || !value.requestId) return null;
  return {
    stoppedAt: value.stoppedAt,
    requestId: value.requestId,
    playerPaused: typeof value.playerPaused === 'boolean' ? value.playerPaused : true,
  };
}

export function isLastSongActive(
  event: Pick<Event, 'lastSongRequestId'> | null | undefined,
  nowPlayingId: string | null | undefined,
): boolean {
  return Boolean(event?.lastSongRequestId && nowPlayingId && event.lastSongRequestId === nowPlayingId);
}

export type LastSongBridgeSupport = 'supported' | 'outdated' | 'no-bridge';

export function lastSongBridgeSupport(level: QueueLevel, bridgeVersion: string | undefined): LastSongBridgeSupport {
  if (level !== 'bridge') return 'no-bridge';
  if (!bridgeVersion || compareVersions(bridgeVersion, LAST_SONG_MIN_BRIDGE_VERSION) < 0) return 'outdated';
  return 'supported';
}

export function buildClearShowStopUpdate(): { showStop: null; lastSongRequestId: null } {
  return { showStop: null, lastSongRequestId: null };
}
